module.exports = __webpack_public_path__ + "img/1.a91d54ed.jpg";